import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheDigitalWorkshopHero from "./sections/TheDigitalWorkshopHero";
import BuiltForYourTrade from "./sections/BuiltForYourTrade";
import TheWebsiteShopAdvantage from "./sections/TheWebsiteShopAdvantage";
import TransparentGrowthTiers from "./sections/TransparentGrowthTiers";
import RecentBuilds from "./sections/RecentBuilds";
import WhatOurClientsSay from "./sections/WhatOurClientsSay";
import ReadyToLevelUp from "./sections/ReadyToLevelUp";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheDigitalWorkshopHero />
      <BuiltForYourTrade />
      <TheWebsiteShopAdvantage />
      <TransparentGrowthTiers />
      <RecentBuilds />
      <WhatOurClientsSay />
      <ReadyToLevelUp />
      <Footer />
    </div>;
}